import CryptoJS from 'crypto-js';
import JSEncrypt from '../assets/js/jsencrypt.min';

//rsa解密
export function decodeHandleRsa(encryptedData, publicKey) {
    // 创建JSEncrypt实例
    const encrypt = new JSEncrypt();
    // 设置公钥
    encrypt.setPublicKey(publicKey)
    return encrypt.decryptLong2(encryptedData);
}

//rsa加密
export function encodeHandleRsa(encryptedData, publicKey) {
    // 创建JSEncrypt实例
    const encrypt = new JSEncrypt();
    // 设置公钥
    encrypt.setPublicKey(publicKey)
    return encrypt.encryptLong2(encryptedData);
}

// AES解密
export function decodeHandleAES(text, keyStr, ivStr = "") {
    const KEY = CryptoJS.enc.Utf8.parse(keyStr)
    let data = {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    };
    if (ivStr) {
        data.iv = CryptoJS.AES.Utf8.parse(ivStr);
    }
    const bytes = CryptoJS.AES.decrypt(text, KEY, data);
    return bytes.toString(CryptoJS.enc.Utf8);
}

// AES加密
export function encodeHandleAES(text, keyStr, ivStr = "") {
    // 定义密钥和待加密的字符事
    const KEY = CryptoJS.enc.Utf8.parse(keyStr);
    let data = {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    };
    if (ivStr) {
        data.iv = CryptoJS.AES.Utf8.parse(ivStr);
    }
    const encrypted = CryptoJS.AES.encrypt(text, KEY, data);
    return encrypted.toString();
}

// 生成随机数
export function generateRandomString(length) {
    const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters[randomIndex];
    }
    return result;
}

// 补0
export function add0(m) {
    return m < 10 ? "0" + m : m;
}

// 20230628
export function formatTime(data) {
    let time = new Date(data);
    let y = time.getFullYear();
    let m = time.getMonth() + 1;
    let d = time.getDate();
    return ('' + y + add0(m) + add0(d));
}

// 2024年6月12日 9:00-12:00
export function formatTime2(data1, data2) {
    let time1 = new Date(data1 * 1000);
    let time2 = new Date(data2 * 1000);
    let y = time1.getFullYear();
    let m = time1.getMonth() + 1;
    let d = time1.getDate();
    let h = time1.getHours();
    let mm = time1.getMinutes();
    let h2 = time2.getHours();
    let mm2 = time2.getMinutes();
    return (y + "年" + m + "月" + d + "日 " + h + ":" + add0(mm) + "-" + h2 + ":" + add0(mm2));
}
